export default "__VITE_ASSET__204fe02b__"